// Terms pass B — shared helpers for the legacy notice screen.
import api from "@/lib/api";

export const L = "/terms/legacy";
export const inp = "rounded-md border border-[#cfd4dc] px-2 py-1.5 text-sm";
export const btn = "px-4 py-1.5 rounded-full bg-[#0072bc] text-white text-sm font-semibold disabled:opacity-50";
export const ghost = "px-3 py-1 rounded-full border border-[#cfd4dc] text-sm disabled:opacity-50";
export const errText = (e) => {
  const d = e?.response?.data?.detail;
  return String(Array.isArray(d) ? d.map((x) => x.msg || x.message).join("; ") : d || e.message);
};
export const call = (method, url, slug, data, extra = {}) =>
  api.request({ method, url: `${L}${url}`, data, params: { tenant_slug: slug }, ...extra }).then((r) => r.data);

export function Card({ title, right, children, testId }) {
  return (
    <section className="bg-white border border-[#e5e7eb] rounded-lg p-4 space-y-3" data-testid={testId}>
      <div className="flex items-center justify-between gap-3 flex-wrap"><h2 className="text-base font-semibold text-[#0e1420]">{title}</h2>{right}</div>
      {children}
    </section>
  );
}
